import { useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "../NotFound/notFound.module.css";
import MetaTags from "../../components/MetaTags";

const NotFound = () => {
  useEffect(() => {
    // Check if the script is already added to avoid duplicate loading
    if (!document.querySelector('script[src="https://unpkg.com/@dotlottie/player-component@latest/dist/dotlottie-player.mjs"]')) {
      const script = document.createElement("script");
      script.src =
        "https://unpkg.com/@dotlottie/player-component@latest/dist/dotlottie-player.mjs";
      script.type = "module";
      document.body.appendChild(script);

      // Cleanup: remove the script if needed
      return () => {
        document.body.removeChild(script);
      };
    }
  }, []);

  return (
    <>
      <MetaTags title="Page Not Found - 404" description="Page Not Found" />
      <section className={styles.sec404}>
      <div className={styles.container}>
        <div className={styles.notFoundContent}>
          <div>
           
           
            <h1>Page not found...</h1>
            <p>
              Sorry, the page you are looking for doesn’t exist or has been
              moved. Try searching our site
            </p>
            <Link to="/">Go to Home</Link>
          </div>
          <div>
          <dotlottie-player
              src="https://lottie.host/8940e580-a48f-48d4-9d2d-0ba6096f1fa6/JnwcA44skl.lottie"
              background="transparent"
              speed="1"
              style={{ width: "90%", height: "90%" }}
              loop
              autoplay
            ></dotlottie-player>
          </div>
        </div>
      </div>
      </section>
    </>
  );
};

export default NotFound;
